<template>
    <div class="dialog">
        <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }">
            <div class="a">四川省安全生产培训教师证书信息查询</div>
            <div class="input">
                <el-input id ="name" v-model="inputData.name" placeholder="姓名" ref="name"></el-input>
                <el-input id="cardId" v-model="inputData.cardId" placeholder="身份证号码" style="margin-top: 15px"></el-input>
                <el-button round class="button" @click="queryCertinfo">查询</el-button>
            </div>
        </el-card>
    </div>
</template>
<script>
 import Vue from 'vue';
 let Base64 = require('js-base64').Base64;
 export default {
     name: 'Query',
     data() {
         var check_user = (rule, value, callback) => {
             if (value === '') {
                 return callback(new Error('用户不能为空'));
             } else {
                 if (this.inputData.user != '' && this.inputData.cardId != '') {
                     this.inputData.beDisabled = false;
                 } else {
                     this.inputData.beDisabled = true;
                 }
                 callback();
             }
         };
         var check_id = (rule, value, callback) => {
             if (!value) {
                 return callback(new Error('身份证不能为空'));
             } else {
                 if (this.inputData.user != '' && this.inputData.cardId != '') {
                     this.inputData.beDisabled = false;
                 } else {
                     this.inputData.beDisabled = true;
                 }
                 callback();
             }
         };
         return {
             inputData: {
                 name: '',
                 cardId: '',
                 beDisabled: true
             },
             rules2: {
                 user: [{
                     validator: check_user,
                     trigger: 'blur'
                 }],
                 password: [{
                     validator: check_id,
                     trigger: 'blur'
                 }],
             }

         }
     },
     methods: {
         queryCertinfo: function() {
             var user = this.inputData.name.replace(/^\s+|\s+$/gm,'');
             var cardId = this.inputData.cardId.replace(/^\s+|\s+$/gm,'')
             var query = user + '#' + cardId;
             this.$http
                 .get('http://120.27.221.176/backend/api/v1/training/certificate/user_lookup/' + encodeURIComponent(query) + '/?format=json')
                 .then(response => {
                     console.log(response.data);
                     this.$router.push({path: './certinfo', query: {info: response.data}});
                 })
                 .catch(error => {
                     console.log(error)
                     this.$message.error({message:'查询失败，请重试', center: true});
                 })
                 .finally(() => {

                 });
         }
     }
 }
</script>
<style scoped>
 html,
 body {
     margin: 0;
     padding: 0;
     position: relative;
 }

 .dialog {
     width: 100%;
     height: 100%;
     text-align: center;
 }

 .card {
     border-radius: 5px;
     border-color: #5BB64D;
     margin: 10px 15px 0 20px;
     transition: all .3s ease-in-out;
 }

 .a {
     height: 53px;
     width: 100%;
     line-height: 52px;
     font-size: 22px;
     font-weight: bold;
     color: #fff;
     background-color: #5BB64D;
     text-align: center;
     display: block;
     text-decoration: none;
 }

 .box-card {
     width: 600px;
     margin:0 auto;
     margin-top: 150px;
     text-align: center;
     border-radius: 5px;
 }

 .button {
     text-decoration: none;
     color: #fff;
     font-size: 16px;
     font-weight: bold;
     background-color: #5BB64D;
     width: 100%;
     margin-top: 15px;
     border-radius: 5px;
     border: 0;
 }

 .button:hover {
     color: #fff;
     background-color: #1C3717;
     text-decoration: none;
 }

 h1 {
     text-align: center;
 }

 .input {
     padding: 30px 50px 30px 50px;
 }

 .item {
     margin-top: 30px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Query.vue